import { CookieKey } from '@lib/cookie-keys.const';

export const I18N_COOKIE_KEY: CookieKey = CookieKey.I18N_LANG;
export const DEFAULT_LANGUAGE = 'en-US';

export const SUPPORTED_LANGUAGES = {
  'en-US': 'English (US)',
  'fr-CA': 'Français (CA)',
  'es-MX': 'Spanish (MX)',
};

// also exists in locale-detection.ejs
export const I18N_LANG_COOKIE_MAP = {
  'en': 'en-US',
  'fr-CA': 'fr-CA',
  'es-MX': 'es-MX',
};
